<template>
  <FreeBottomSheet :name="name">
    <div class="space-y-6 p-4">
      <h2 class="text-text-neutral-primary text-xl font-semibold">
        App Version & Cache Info
      </h2>
      <div class="space-y-4">
        <div class="space-y-2">
          <h3 class="text-text-neutral-primary text-lg font-medium">
            Version Information
          </h3>
          <div class="bg-background-neutral-primary space-y-2 rounded-lg p-3">
            <div class="flex justify-between">
              <span class="text-text-neutral-secondary">App version:</span>
              <span class="text-text-neutral-primary">{{ appVersion }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-text-neutral-secondary">RC App version:</span>
              <span class="text-text-neutral-primary">
                {{
                  firebaseStore?.serializedRemoteConfig?.app_version ||
                  'Not loaded'
                }}
              </span>
            </div>
          </div>
        </div>

        <div class="space-y-2">
          <h3 class="text-text-neutral-primary text-lg font-medium">
            Cache Management
          </h3>
          <div class="bg-background-neutral-primary space-y-3 rounded-lg p-3">
            <div class="flex items-center justify-between">
              <span class="text-text-neutral-secondary">Cache status:</span>
              <span class="text-text-neutral-primary text-sm">
                {{ cacheStatus }}
              </span>
            </div>
            <button
              class="bg-background-positive-primary text-static-white hover:bg-background-info-accent w-full rounded px-4 py-2 transition-colors"
              type="button"
              @click="clearCache"
            >
              Clear Cache
            </button>
          </div>
        </div>
      </div>
    </div>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { onMounted, onUnmounted, ref } from 'vue';
  import {
    FreeBottomSheet,
    cacheConfig,
    freedomApp,
    useFirebaseStore,
  } from 'freedom-shared';

  interface Props {
    name: string;
  }

  defineProps<Props>();

  const appVersion = import.meta.env.VITE_APP_VERSION || 'Not loaded';

  const cacheStatus = ref(
    sessionStorage.getItem('cacheStatus') ||
      cacheConfig.CACHE_NOT_CLEARED_MESSAGE,
  );

  const firebaseStore = useFirebaseStore();

  const handleStorageChange = (e: StorageEvent) => {
    if (e.key === 'cacheStatus') {
      cacheStatus.value = e.newValue || cacheConfig.CACHE_NOT_CLEARED_MESSAGE;
    }
  };

  onMounted(() => {
    window.addEventListener('storage', handleStorageChange);
  });

  onUnmounted(() => {
    window.removeEventListener('storage', handleStorageChange);
  });

  const clearCache = () => {
    sessionStorage.setItem(
      'cacheStatus',
      cacheConfig.CACHE_CLEARED_MESSAGE_MANUALLY,
    );
    cacheStatus.value = cacheConfig.CACHE_CLEARED_MESSAGE_MANUALLY;
    freedomApp.lib.clearCache();
  };
</script>
